import React from 'react'
import './LoadingSpinner.scss'

const LoadingSpinner = () => (
  <div className='center-spinner'>
    <span className='spinner-label'>Loading...</span>
    <div className='spinner-loader' />
  </div>
)

export default LoadingSpinner
